import { useRef, useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';
import { axiosPrivate } from '../api/axios';
import {Anchor, TextInput, PasswordInput, Group, Button, Container, Title, Text, Paper, Stack } from '@mantine/core'
import './Login.css';
import {ReactComponent as Logo} from '../icons/zeitview_logo.svg'

const LOGIN_URL = '/api/getAuthToken';

const Login = () => {
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axiosPrivate.post(LOGIN_URL,
                JSON.stringify({ username: user, password: pwd })
            );
            const accessToken = response?.data?.accessToken;
            const auth = {user, accessToken};
            setAuth(auth);
            sessionStorage.setItem('aimauth', JSON.stringify(auth));
            setUser('');
            setPwd('');
            navigate(from, { replace: true });
        } catch (err) {
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        }
    }

    return (
        <Container size={420} my={40}>
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
        <Title align="center" sx={(theme) => ({
          fontFamily: `Greycliff CF, ${theme.fontFamily}`,
          fontWeight: 600
        })}><Logo />  Autoloader</Title>
        <Text color="dimmed" size="sm" align="center" mt={5}>
        Do not have an account yet? Contact DataOps team. </Text>

        
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
            
        <form onSubmit={handleSubmit}>
            <Stack>
            <TextInput
                type="text"
                id="username"
                label="UserName Or Email:"
                placeholder='Enter your username or email'
                ref={userRef}
                autoComplete="off"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                required
            />

            <PasswordInput
                type="password"
                id="password"
                label="Password:"
                placeholder='Enter your password'
                onChange={(e) => setPwd(e.target.value)}
                value={pwd}
                required
            />
            </Stack> 

            <Group justify="right" mt="xl">
                <Anchor component="button" type="button" c="dimmed" onClick={() => navigate('/forgot-password')}>Forgot password?</Anchor>
                <Button type="submit" radium="lg">Sign In</Button>
            </Group>
        </form>       
        
        </Paper>
        </Container>
    )
}

export default Login